import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Absence from '../../components/tables/Absence.jsx';
import { getAllEmployees } from '../../services/EmployeeService';
import PageHeader from '../../components/headers/Header';
import AbsenceDetailsModal from '../../components/DViews/AbsenceDetailsModal';
import DayDetailsModal from '../../components/DViews/CDayDetails.jsx';
import AbsenceDashboard from '../../components/dash/AbsenceDash';
import JustificationUploadModal from '../../components/DViews/JUModal.jsx';
import ElegantAddButton from '../../components/btns/AddButton.jsx';
import { getAbsencesByTypeAndMonth, getMyAbsences, getAllStagedAbsences } from '../../services/absenceAPIs';
import { useMediaQuery } from '@mui/material';
import '../../components/leaves/Leaves.css';

const Lateness = () => {
  const navigate = useNavigate();
  const [IsEmployee, setIsEmployee] = useState(localStorage.getItem('userRole') === 'EMPLOYEE');
  const [stagedAbsences, setStagedAbsences] = useState([]);
  const isLargeScreen = useMediaQuery('(min-width: 1600px)');
  const location = useLocation();
  const [selectedAbsence, setSelectedAbsence] = useState(null);
  const [employees, setEmployees] = useState([]);
  const [lateAbsences, setLateAbsences] = useState([]);
  const [activeTab, setActiveTab] = useState(IsEmployee ? 'add' : 'overview');
  const [selectedCalendarDate, setSelectedCalendarDate] = useState(null);
  const [dayAbsences, setDayAbsences] = useState([]);
  const [showDayDetailsModal, setShowDayDetailsModal] = useState(false);
  const [selectedUpload, setSelectedUpload] = useState(null);

  const initialFilters = {
    type: '',
    status: '',
    department: '',
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
    search: '',
    includeLateness: true
  };

  const [filters, setFilters] = useState(initialFilters);

  useEffect(() => {
    const state = location.state || {};
    setActiveTab(state.targetTab || (IsEmployee ? 'add' : 'overview'));

    if (state.filters) {
      setFilters(prevFilters => ({
        ...prevFilters,
        year: state.filters.year || prevFilters.year,
        month: state.filters.month || prevFilters.month,
        office: state.filters.office === 'all' ? '' : state.filters.office || prevFilters.office,
      }));
    }

    if (state.targetTab) delete state.targetTab;
  }, [location.state, IsEmployee]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const allEmployees = await getAllEmployees();
        setEmployees(allEmployees);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  const [absences, setAbsences] = useState([]);

  const fetchAbsences = async () => {
    try {
      let data = [];
      const stagedAbsencesData = await getAllStagedAbsences();
      if (IsEmployee) {
        data = await getMyAbsences();
      } else {
        data = await getAbsencesByTypeAndMonth('LATENESS', filters.year, filters.month);
      }
      setAbsences(data);
      setStagedAbsences(stagedAbsencesData);
      setLateAbsences(data.filter(abs => abs.ty_pe === 'LATENESS'));
    } catch (error) {
      console.error('Error fetching absences:', error);
    }
  };

  useEffect(() => {
    fetchAbsences();
  }, [IsEmployee, filters.year, filters.month]);

  useEffect(() => {
    if (IsEmployee && activeTab === 'overview') {
      setActiveTab('add');
    } else if (!IsEmployee && activeTab === 'add') {
      setActiveTab('overview');
    }
  }, [IsEmployee]);

  return (
    <div>
      <PageHeader
        title="Lateness"
        subtitle="Track and manage employee lateness records"
        actions={<>
          <ElegantAddButton text="Add Lateness" onClick={() => navigate('/lateness/add')} />
          <ElegantAddButton text="Confirm Lateness" onClick={() => navigate('/unconfirmed', { state: { absenceType: 'LATENESS' } })} />
        </>}
      />
      <AbsenceDashboard IMGemployees={employees} late={true} />
      <div id="absences-container">
        <Absence
          filters={filters}
          setFilters={setFilters}
          setSelectedAbsence={setSelectedAbsence}
          absences={lateAbsences}
          setSelectedUpload={setSelectedUpload}
          unconfirmed={false}
          fetchAbsences={fetchAbsences}
          IsEmployee={IsEmployee}
          late={true}
        />
      </div>
      {selectedAbsence && (
        <AbsenceDetailsModal
          selectedAbsence={selectedAbsence}
          setSelectedAbsence={(val) => {
            setSelectedAbsence(val);
          }}
          fetchAbsences={fetchAbsences}
          IsEmployee={IsEmployee}
        />
      )}
      {selectedUpload && (
        <JustificationUploadModal
          selectedUpload={selectedUpload}
          setSelectedUpload={(val) => {
            setSelectedUpload(val);
          }}
          fetchAbsences={fetchAbsences}
        />
      )}
      <DayDetailsModal
        open={showDayDetailsModal}
        onClose={() => setShowDayDetailsModal(false)}
        selectedDate={selectedCalendarDate}
        dayAbsences={dayAbsences}
        employees={employees}
      />
    </div>
  );
};

export default Lateness;